//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "./Header";
//Install
import P57859 from "./Content/P57859";
//Install
import H57G68 from "./Content/H57G68";
//Install
import N2C359 from "./Content/N2C359";
//Install
import G9761D from "./Content/G9761D";
//Install
import K820Q1 from "./Content/K820Q1";
//Install
import Q96F2K from "./Content/Country/Q96F2K";
//Install
import M42V32 from "./Content/Country/M42V32";
//Install
import N7158R from "./Content/Services/N7158R";
//Install
import Q6U600 from "./Content/Services/Q6U600";
//Install
import A14F86 from "./Content/Services/A14F86";
//Install
import S058JF from "./Content/Reference/S058JF";
//Install
import P8932D from "./Content/Reference/P8932D";
//Install
import Q901RJ from "./Content/Reference/Q901RJ";
//Install
import B01KQ8 from "./Content/Reference/B01KQ8";
//Install
import DB6F84 from "./Content/Reference/DB6F84";
//Install
import Z512OJ from "./Content/Reference/Z512OJ";
//Install
import H03U9W from "./Content/Services/H03U9W";
//Install
import OZ073M from "./Content/Services/OZ073M";
//Install
import B1H575 from "./Content/Services/B1H575";
//Install
import E3Z06E from "./Content/Services/E3Z06E";
//Install
import T322PN from "./Content/Services/T322PN";
//Install
import C433SJ from "./Content/Services/C433SJ";
//Install
import Footer from "./Footer";

//Element
class Main extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Temas Elektrik Taahhüt - Anasayfa"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik, Sürdürülebilir ve Güvenilir Enerji Hizmetleri İle Her Dokunuş, Geleceği Değer Katar."
        //Element
        let URL = "https://temaselektrik.com/"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB y4vg30" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement(N2C359, {})
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB w94400" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(P57859, {})
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB k1h2z5" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 4 },
                                //Element
                                React.createElement(T322PN, { ID: "0", Title: "Elektrik ve Mekanik Taahhüt", Target: "/sunulan-hizmetler/elektrik-taahhut" })
                            ),
                            //Element
                            React.createElement(Col, { md: 4 },
                                //Element
                                React.createElement(C433SJ, { ID: "0", Title: "İşletme ve Bakım", Target: "/sunulan-hizmetler/orta-gerilim-tesisleri" })
                            ),
                            //Element
                            React.createElement(Col, { md: 4 },
                                //Element
                                React.createElement(E3Z06E, { ID: "0", Title: "Aydınlatma", Target: "/sunulan-hizmetler/aydinlatma" })
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB w94400" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(K820Q1, {})
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB w94400" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement(H57G68, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement(OZ073M, {}),
                                //Element
                                React.createElement(B1H575, {}),
                                //Element
                                React.createElement(Q6U600, {}),
                                //Element
                                React.createElement(N7158R, {}),
                                //Element
                                React.createElement(A14F86, {}),
                                //Element
                                React.createElement(H03U9W, {})
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB v787uv" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 2 },
                                //Element
                                React.createElement(P8932D, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 2 },
                                //Element
                                React.createElement(Q901RJ, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 2 },
                                //Element
                                React.createElement(S058JF, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 2 },
                                //Element
                                React.createElement(B01KQ8, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 2 },
                                //Element
                                React.createElement(Z512OJ, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 2 },
                                //Element
                                React.createElement(DB6F84, {})
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB d44n75 d-none" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement(M42V32, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement(Q96F2K, {})
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB e05dl5" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement(G9761D, {})
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Main;